//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PaymentSourceType } from './Enums';

export class PaymentSourceDisplayItem extends ItemBase {
    ID: string | null = null;
    PaymentProcessorID: string | null = null;
    ParentID: string | null = null;
    Issuer: string | null = null;
    DisplayText: string | null = null;
    AutoPay: boolean = false;
    IsVerified: boolean = false;
    ExpiryDate: string | null = null;
    VerificationUrl: string | null = null;
    OrderIndex: number = 0;
    Type: PaymentSourceType = PaymentSourceType.BankAccount;

    constructor(initializer?: Partial<PaymentSourceDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PaymentSourceDisplayItem";
}
